"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useMemo, useRef } from "react";
import makeStyles from "../../theming/make-styles.js";
const useStyles = makeStyles()((_, { block }) => ({
    table: {
        position: "relative",
        display: "table",
        width: "100%",
        borderCollapse: "collapse",
        borderSpacing: 0,
    },
    scrollWrapper: {
        height: "100%",
        overflowX: "auto",
    },
    tableWrapper: {
        width: block ? "100%" : undefined,
        maxWidth: "100%",
    },
}));
export const TableSectionContext = React.createContext({ parent: "TableBody", parentColor: undefined });
export const TableContext = React.createContext({
    borders: { horizontal: { body: "between" } },
    eventTarget: undefined,
    selectable: false,
    size: "large",
    sticky: false,
});
export const Table = React.forwardRef(function Table(_a, ref) {
    var { block, borders = { horizontal: { body: "between" } }, children, className, headingOverlay, selectable = false, size = "large", sticky = false } = _a, props = __rest(_a, ["block", "borders", "children", "className", "headingOverlay", "selectable", "size", "sticky"]);
    const { classes, cx } = useStyles({ block });
    const eventTargetRef = useRef(typeof EventTarget !== "undefined" ? new EventTarget() : null);
    const innerRef = useRef(ref);
    function handleScroll({ currentTarget: target }) {
        var _a;
        (_a = eventTargetRef.current) === null || _a === void 0 ? void 0 : _a.dispatchEvent(new CustomEvent("scroll", {
            detail: {
                scroll: target.scrollLeft,
                width: target.clientWidth,
            },
        }));
    }
    useEffect(() => {
        function onResize() {
            var _a, _b, _c;
            (_a = eventTargetRef.current) === null || _a === void 0 ? void 0 : _a.dispatchEvent(new CustomEvent("resize", {
                detail: {
                    scroll: ((_b = innerRef.current) === null || _b === void 0 ? void 0 : _b.scrollLeft) || 0,
                    width: ((_c = innerRef.current) === null || _c === void 0 ? void 0 : _c.clientWidth) || 0,
                },
            }));
        }
        window.addEventListener("resize", onResize);
        return () => window.removeEventListener("resize", onResize);
    }, [innerRef]);
    const contextValue = useMemo(() => ({ borders, eventTarget: eventTargetRef.current, selectable, size, sticky }), [borders, selectable, size, sticky]);
    return (_jsx(TableContext.Provider, { value: contextValue, children: _jsxs("div", Object.assign({ ref: ref, className: cx(classes.tableWrapper, className), "data-component": "table" }, props, { children: [headingOverlay, _jsx("div", { ref: innerRef, className: classes.scrollWrapper, onScroll: handleScroll, children: _jsx("table", { className: classes.table, children: children }) })] })) }));
});
export default Table;
//# sourceMappingURL=table.js.map